import { render } from "./BannedModal.vue?vue&type=template&id=62786fc8&scoped=true"
import script from "./BannedModal.vue?vue&type=script&lang=js"
export * from "./BannedModal.vue?vue&type=script&lang=js"

import "./BannedModal.vue?vue&type=style&index=0&id=62786fc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62786fc8"]])

export default __exports__